<template>
  <footer id="kt_app_footer" class="py-4 app-footer">
    <div class="app-container container-fluid d-flex flex-column flex-md-row flex-center flex-md-stack py-3 justify-content-center">
      <div class="d-flex justify-content-center align-items-center gap-5">
        <img src="/images/favicon/favicon-32.png" alt="">
        <p class="mb-0 text-white font-size-xSmall">
          PIXEL ROADS LTDA - ©{{ currentYear }} | {{ $t('all_rights_reserved') }}
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'TheFooter',
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.app-footer {
  background-color: $color9;
}

</style>
